import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/settings/properties')({
  beforeLoad: () =>
    redirect({
      to: '/settings/tenant',
      search: { phoneVersion: 'v1' },
      replace: true,
    }),
});
